// extracted by mini-css-extract-plugin
module.exports = {"custom":"card_custom__1F1oj","lightBox":"card_lightBox__1Heb5","item":"card_item__1rOy6"};